import React from "react";
import "./bread.scss";
import "../../../styles/fontSizes.scss";
import Crums from "componets/atoms/crums/crums";
/*Ejemplo de datos:
data = [{text: "", link: ""}, {text: "", link: ""}, {text: "", link: ""}]
*/

const Bread = ({ data, textSize }) => {
  return (
    <div className={`bread__container font-size--${textSize}`}>
      <p className={`font-size--${textSize}`}>Estás en: </p>
      {data &&
        data.map((crum, index) => (
          <React.Fragment key={index}>
            <Crums
              className={`font-size--${textSize}`}
              link={crum.link}
              text={crum.text}
            ></Crums>
            <label
              className={`bread__symbol--${
                index < data.length - 1 ? "normal" : "final"
              }`}
            ></label>
          </React.Fragment>
        ))}
    </div>
  );
};

export default Bread;
